import React, { Component } from 'react';
import { isSupportedVariable } from '../lib/extraVariables';
import _each from 'lodash/each';
import _head from 'lodash/head';
import _map from 'lodash/map';
import _isEmpty from 'lodash/isEmpty';
import getLocaleMessages from '../utils/localesMessages';
import PropTypes from 'prop-types';

const {
	extraVariable,
	oneInvalidVariable,
	manyInvalidVariables
} = getLocaleMessages('buttons/fieldErrors');

class ExtraVariablesTextArea extends Component {
	state = {
		errors: ''
	}

	static propTypes = {
		input: PropTypes.object,
		label: PropTypes.string,
		meta: PropTypes.object,
		id: PropTypes.string,
		validateOnBlur: PropTypes.bool,
	}

	handleBlur = (event) => {
		const {
			input,
		} = this.props;

		this.setState({
			errors: this.getErrorHtml(input.value)
		})
	}

	getErrorHtml = (value) => {
		const variables = value.split('\n');
		let unsupportedVariables = [];
		_each(variables, (variable) => {
			const key = _head(variable.split('='));
			if (key && !isSupportedVariable(key)) {
				unsupportedVariables.push(key)
			}
		})

		if (_isEmpty(unsupportedVariables)) {
			return null;
		}

		return (
			<div className="error-block">
				<div className="error-icon">
					<span className="vx_selectIcon_error"></span>
				</div>
				<div className="error-message">
					<div className="line-1">
						{
							unsupportedVariables.length === 1 ?
							oneInvalidVariable :
							manyInvalidVariables
						}
					</div>
					<div className="line-2">
						{
							unsupportedVariables.length === 1 ?
							<div>{extraVariable.oneUnsupportedVariable}</div> :
							<div>{extraVariable.manyUnsupportedVariables}</div>
						}
						<ul>
							{
								_map(unsupportedVariables, (variable, index) => {
									return (
										<li key={index}>{variable}</li>
									)
								})
							}
						</ul>
					</div>
				</div>
			</div>
		)
	}

	render() {
		const {
			input,
			meta: { touched, error, active },
			id,
			validateOnBlur
		} = this.props;

		let hasError = validateOnBlur ? !active && touched && error : touched && error;

		return (
			<div className={`extra-variables-text-area ${hasError ? 'has-error' : ''}`}>
				<div>
					<textarea
						id={id}
						{...input}
						onBlur={(event) => {
							input.onBlur(event);
							this.handleBlur(event);
						}}
					/>
					{this.state.errors}
				</div>
			</div>
		);
	}
}

export default ExtraVariablesTextArea;



// WEBPACK FOOTER //
// ./buttons/components/ExtraVariablesTextArea.js